// extracted by mini-css-extract-plugin
var _1 = "OverviewBoxStyle-module__box___hUM1q";
var _2 = "OverviewBoxStyle-module__box-amount___zxaPV";
var _3 = "OverviewBoxStyle-module__box-amount-large___nxOhI";
var _4 = "OverviewBoxStyle-module__box-amount-small___lmrWL";
var _5 = "OverviewBoxStyle-module__box-label___sVt2L";
var _6 = "OverviewBoxStyle-module__box-one-liner___OdvRl";
var _7 = "OverviewBoxStyle-module__box-amount___zxaPV";
var _8 = "OverviewBoxStyle-module__box-amount-large___nxOhI";
var _9 = "OverviewBoxStyle-module__box-amount-small___lmrWL";
var _a = "OverviewBoxStyle-module__box-label___sVt2L";
var _b = "OverviewBoxStyle-module__box-one-liner___OdvRl";
export { _1 as "box", _2 as "box-amount", _3 as "box-amount-large", _4 as "box-amount-small", _5 as "box-label", _6 as "box-one-liner", _7 as "boxAmount", _8 as "boxAmountLarge", _9 as "boxAmountSmall", _a as "boxLabel", _b as "boxOneLiner" }
